namespace RedBullMOBILE360.BulkSMS {
    export interface MessageExcelFile extends Serenity.ServiceRequest {
        Message?: string;
        IsMessageIncluded?: boolean;
        SendNow?: boolean;
        SendDate?: string;
        SendDate2?: string;
        SendDate3?: string;
        SenderId?: number;
        SMMPAccount?: number;
        FileName?: string;
    }
}
